import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://via.placeholder.com/40x40.png?text=back",
  alt: "back"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Products", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 p-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Price comparison app", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = { class: "input-group-append" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, { to: { name: 'home' } }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Product barcode",
                "aria-label": "Product title or barcode",
                "aria-describedby": "basic-addon2"
              }, null, 512), [
                [_vModelText, _ctx.keyword]
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchProductClicked && _ctx.searchProductClicked(...args))),
                  type: "button"
                }, " Search ")
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "border p-2 mb-4 row"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: _ctx.getProductImageByBarcode(item.barcode),
                alt: "product"
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'product-details', params: { id: item.id } },
                  class: "text-dark"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128)),
        (_ctx.productCount === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createTextVNode(" Product not found. "),
              _createVNode(_component_RouterLink, {
                to: { name: 'product-create', params: { barcode: this.barcode } },
                class: "text-dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add product ")
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}